import * as tslib_1 from "tslib";
import { JobTriggerType, } from '@models';
import { GridPageState, ODataGridComponent, } from '@pages/generics/grid';
var JobTriggersGridComponent = /** @class */ (function (_super) {
    tslib_1.__extends(JobTriggersGridComponent, _super);
    function JobTriggersGridComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.JobTriggerType = JobTriggerType;
        return _this;
    }
    Object.defineProperty(JobTriggersGridComponent.prototype, "jobId", {
        set: function (value) {
            this._state$.next(GridPageState.pending);
            this._filters$.next([{
                    method: 'eq',
                    property: 'jobId',
                    value: value,
                }]);
            this._state$.next(GridPageState.ready);
        },
        enumerable: true,
        configurable: true
    });
    JobTriggersGridComponent.prototype.toggleRow = function (entity) {
        this.expandedRow = this.expandedRow === entity
            ? undefined
            : entity;
    };
    return JobTriggersGridComponent;
}(ODataGridComponent));
export { JobTriggersGridComponent };
